import React, { useState } from "react";
import { useDensity } from "@/hooks/use-density";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { LayoutGrid, Rows3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function DensityToggle() {
  const { density, setDensity, isCompact } = useDensity();
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);

  const handleSelect = (value: "comfortable" | "compact") => {
    setDensity(value);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 min-w-[36px] px-2"
          title={t("common:density") || "Hustota rozhrania"}
        >
          <Rows3 className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2" align="end">
        <div className="space-y-1">
          <p className="px-2 py-1.5 text-sm font-medium text-muted-foreground">
            {t("common:density") || "Hustota rozhrania"}
          </p>
          <button
            onClick={() => handleSelect("comfortable")}
            className={cn(
              "flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm transition-colors",
              !isCompact
                ? "bg-primary/10 text-primary font-medium"
                : "hover:bg-muted"
            )}
          >
            <LayoutGrid className="h-4 w-4" />
            {t("common:densityComfortable") || "Comfortable"}
          </button>
          <button
            onClick={() => handleSelect("compact")}
            className={cn(
              "flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm transition-colors",
              isCompact
                ? "bg-primary/10 text-primary font-medium"
                : "hover:bg-muted"
            )}
          >
            <Rows3 className="h-4 w-4" />
            {t("common:densityCompact") || "Compact"}
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
